'use client';
import { normalizeColorLabel } from '@/lib/color-url';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import { BrowserPersistence } from '@/util';
import resourceUrl from '@/util/makeUrl';
import useEmblaCarousel from 'embla-carousel-react';
import Link from 'next/link';

import { NextButton, PrevButton, usePrevNextButtons } from './EmblaCarouselArrowButtons';
import itemClasses from './customizeOptions.module.css';
import classes from './embla.module.css';
const EmblaCarousel = props => {
  const { slides, options, url_key, selectedColor, handleClick } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  const { isMobile } = useIsMobile();
  const showBtnNumber = isMobile ? 3 : 4;
  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

  return (
    <section className={cn(classes.embla)}>
      <div
        className={cn(classes.emblaViewport)}
        style={{ width: isMobile ? (slides && slides.length < 5 ? '100%' : 'calc(100% - 42px)') : 'calc(100% - 42px)' }}
        ref={emblaRef}
      >
        <div
          className={cn(classes.emblaContainer)}
          style={{ justifyContent: slides && slides.length < 5 ? 'center' : '' }}
        >
          {slides &&
            slides.map((item, index) => (
              <div
                className={cn(classes.emblaSlide)}
                key={index}
              >
                <Item
                  value={item}
                  isMobile={isMobile}
                  url_key={url_key}
                  selectedColor={selectedColor}
                  index={index}
                  key={index}
                  handleClick={handleClick}
                />
              </div>
            ))}
        </div>
      </div>
      {slides && slides.length > showBtnNumber && (
        <div className={cn(classes.emblaControls)}>
          <div className={cn(classes.emblaButtons)}>
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />
            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      )}
    </section>
  );
};

function Item({ value, isMobile, url_key, index, selectedColor, handleClick }) {
  const storage = new BrowserPersistence();

  const storeCode = storage.getItem('store_view_code') || process.env.NEXT_PUBLIC_STORE_VIEW_CODE;

  const getLink = colorValue => {
    const basePath = storeCode === 'hisea_de' ? '/de' : '';
    const colorPath = colorValue ? `-${normalizeColorLabel(colorValue.label)}` : '';

    return resourceUrl(`${basePath}/${url_key}${colorPath}.html`);
  };
  const size = isMobile ? 310 : 340;
  const height = isMobile ? 392 : 430;
  const rgb = value?.rgb ?? '';
  const blockStyle = /^#\S+$/.test(rgb)
    ? {
        backgroundColor: rgb,
      }
    : {
        backgroundImage: `url(${process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL}media/attribute/swatch/swatch_thumb/110x90${rgb})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      };
  const bgSrc = value?.image ?? '';
  const bgStyle = {
    backgroundImage: `url(${bgSrc})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  const itemClass = selectedColor?.rgb === rgb ? itemClasses.activeItem : itemClasses.item;
  const productLink = getLink(value);
  return (
    <Link
      href={productLink}
      aria-hidden='true'
      className={itemClass}
      key={index}
      onClick={e => {
        e.preventDefault();
        if (value && handleClick) {
          handleClick(value);
        }
      }}
      style={bgStyle}
    />
  );
}

export default EmblaCarousel;
